// product grid/list
function listgridJavascript() {
Array.from(document.querySelectorAll(".tmlistgridbtn")).forEach(link => {
    link.addEventListener('click', function(event) {
        Array.from(document.querySelectorAll(".tmlistgridbtn")).forEach(e => e.classList.remove('active'));
        this.classList.add('active');
        if(this.classList.contains('listv')){
            document.getElementById('product-grid').classList.add('product-list');
            document.getElementById('product-grid').classList.remove('product-grid');
        }else if(this.classList.contains('gridv')){
            document.getElementById('product-grid').classList.add('product-grid');
            document.getElementById('product-grid').classList.remove('product-list');
        }
    }); 
});
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// CARD PRODUCT TIMER

// setInterval(productCardCountdown, 1000);
// function productCardCountdown() {
//   const countCardSections = document.querySelectorAll('.tmcard_countd');
//   countCardSections.forEach((countCardSection) => {
//     var countDownDate = new Date(countCardSection.getAttribute('data-date')).getTime();
//     var now = new Date().getTime();
//     var distance = countDownDate - now;
//     if (distance < 0 || isNaN(countDownDate)) {
//       countCardSection.querySelector('.main_cardday .tm_cardday').textContent = "00";
//       countCardSection.querySelector('.main_cardhour .tm_cardhour').textContent = "00";
//       countCardSection.querySelector('.main_cardminute .tm_cardminute').textContent = "00";
//       countCardSection.querySelector('.main_cardsecond .tm_cardsecond').textContent = "00";
//     }
//     else {
//       countCardSection.querySelector('.main_cardday .tm_cardday').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
//       countCardSection.querySelector('.main_cardhour .tm_cardhour').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       countCardSection.querySelector('.main_cardminute .tm_cardminute').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       countCardSection.querySelector('.main_cardsecond .tm_cardsecond').textContent = Math.floor((distance % (1000 * 60)) / 1000);
//     }
//   });
// }

setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
      var countDownDate = countdownSection.getAttribute('data-date');
      var now = new Date().getTime();

      if (!countDownDate) {
          countdownSection.querySelector('.main_cdays .tm_cdays').textContent = '00';
          countdownSection.querySelector('.main_chours .tm_chours').textContent = '00';
          countdownSection.querySelector('.main_cminutes .tm_cminutes').textContent = '00';
          countdownSection.querySelector('.main_cseconds .tm_cseconds').textContent = '00';
      } else {
          countDownDate = new Date(countDownDate).getTime();
          var distance = countDownDate - now;

          if (distance < 0 || isNaN(countDownDate)) {
              countdownSection.style.display = 'none';
              document.getElementById('countdownMessage').style.display = 'block';
          } else {
              countdownSection.querySelector('.main_cdays .tm_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
              countdownSection.querySelector('.main_chours .tm_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              countdownSection.querySelector('.main_cminutes .tm_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              countdownSection.querySelector('.main_cseconds .tm_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
          }
      }
  });
}